import { useState, useEffect } from "react";
import { useLensApp } from "../useLensApp.jsx";

export default function OutputSection() {
  const { outputKey, outputOptions, matchInputOutputKey, actions } = useLensApp();
  const [pending, setPending] = useState(outputKey);

  useEffect(() => {
    setPending(outputKey);
  }, [outputKey]);

  return (
    <section>
      <h3>Output</h3>
      <div className="field">
        <label htmlFor="outputResolutionSelect">Engine resolution</label>
        <select
          id="outputResolutionSelect"
          value={pending}
          onChange={(event) => setPending(event.target.value)}
        >
          <option value={matchInputOutputKey}>Match input</option>
          {outputOptions.map((option) => (
            <option key={option.key} value={option.key}>{option.label}</option>
          ))}
        </select>
      </div>
      <div className="button-row">
        <button
          className="primary"
          onClick={() => actions.applyOutputResolution(pending).catch(actions.setError)}
        >
          Apply Output
        </button>
      </div>
    </section>
  );
}
